import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { auditTime, filter } from 'rxjs/operators';
import { Product } from '@/app/shared/interface/product.interface';
import { PagingResponseModel } from '@/app/shared/interface/pagination.interface';
import { ProductService } from '@/app/shared/services/product.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-purchased-product',
  templateUrl: './purchased-product.component.html',
  styleUrls: ['./purchased-product.component.scss']
})
export class PurchasedProductComponent implements OnInit, OnDestroy {
  purchasedProducts: Product[] = [];

  public limit = 10;
  public offset = 0;
  public totalItems = 0;
  public isLoading = false;
  public isLastPage = false;

  constructor(
    private productService: ProductService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  private scrollSub: Subscription;

  ngOnInit() {
    this.getPurchasedProducts();
    if (isPlatformBrowser(this.platformId)) {
      this.setupScrollListener();
    }
  }

  ngOnDestroy() {
    this.scrollSub?.unsubscribe();
  }

  setupScrollListener() {
    this.scrollSub = fromEvent(window, 'scroll')
      .pipe(
        auditTime(200),
        filter(() => !this.isLoading && !this.isLastPage && (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 800)
      )
      .subscribe(() => this.getPurchasedProducts());
  }

  getPurchasedProducts() {
    if (this.isLoading) return;
    this.isLoading = true;

    const params = {
      limit: this.limit,
      offset: this.offset
    };

    this.offset += this.limit;

    const handleRes = (res: PagingResponseModel<Product>) => {
      this.isLoading = false;
      if (res.data && res.data.length > 0) {
        // currentTier dùng cho progress bar trong app-product-box-vertical
        res.data.forEach((product: Product) => {
          product.currentTier = product.tieredPrices?.find((x: any) => x.pricingTableId == product.appliedPricingTable?.id);
        });

        this.purchasedProducts = [...this.purchasedProducts, ...res.data];
        this.totalItems = res.total;
        if (res.data.length < this.limit) {
          this.isLastPage = true;
        }
      } else {
        this.isLastPage = true;
      }
    };

    this.productService.getPurchasedProducts(params).subscribe({
      next: (res) => {
        handleRes(res);
      },
      error: (err) => {
        console.error('API error:', err);
        this.isLoading = false;
      }
    });
  }
}
